<template>
    <div class="selectOperator" ref="selectOperator">
        <div class="select__body">
            <span v-translate tabindex="0" aria-live="assertive" :title="$gettext('Instrucciones para seleccionar agente')">{{$gettext('selecciona un agente disponible')}}</span>
            <ul v-if="operators.length > 0" class="operators-list" style="list-style: none; ">
                <li class="operator-item" v-for="operator in operators" :key="operator.operatorid">
                    <button class="operator" 
                            :title="$gettext('Seleccionar agente') + ' ' + operator.name"
                            @click="operator.status.id == 0 && chooseOperator(operator.operatorid)">
                        <div class="operator__img">
                            <img tabindex="-1" class="image" v-if="operator.vcavatar && avatarsStatus[operator.operatorid]" :src="operator.vcavatar" :alt="$gettext('Foto del agente') + ' ' + operator.name">
                            <div v-else class="agent__initial">
                              <p>{{ operator && operator.name.charAt(0) }}</p>
                            </div>
                            <div class="status-indicator"
                                :aria-label="options.operator[operator.status?.id].translation"
                                :class="options.operator[operator.status?.id].status">
                            </div>
                        </div>
                        <div class="operator-name">{{ operator.name }}</div>
                        <div class="flags-container">
                          <img
                              class="flag"
                              v-for="language in operator.vcelanguage"
                              :src="require(`@/assets/flags/${language}.svg`)"
                              :alt="options.language[language].translation" />
                        </div>
                        <div :aria-label="options.camera[parseInt(operator.available_camera)].translation"
                             class="call-icon" :class="options.camera[parseInt(operator.available_camera)].class"></div>
                    </button>
                </li>
            </ul>
        </div>
        <div class="select__random">
            <button :title="$gettext('Acceder al formulario de contacto')" @click="offlineForm">{{ $gettext('Formulario de contacto') }}</button>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import '@/assets/css/pws-icons.css';
import { EventBus } from '@/event-bus';
import DefaultResponses from './ChatContent/DefaultResponses.vue';
import { changeChatWindowStatus, showLoadingScreen } from '../utils';

export default {
    name: 'SelectOperator',
    components: {
        DefaultResponses
    },
    data() {
        return{
            settings: {
                infinite: true,
                speed: 500,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                draggable: false,

            },
            options: {
                operator:{
                    0: {status: 'active',translation: this.$gettext('Operador disponible')},
                    1: {status: 'away',translation: this.$gettext('Operador ausente')},
                    2: {status: 'inactive',translation: this.$gettext('Operador ocupado')}
                },
                language: {
                    'ES': {translation: this.$gettext('Español')},
                    'EN': {translation: this.$gettext('Inglés')}
                },
                camera: {
                    1: {class: 'call-active', translation: this.$gettext('Cámara disponible')},
                    0: {class: 'call-inactive', translation: this.$gettext('Cámara no disponible')}
                },
            },
        
            avatarsStatus: {},
            operatorsLoaded: false,
            isHandlingEmptyOperators: false
        }
    },
    computed: {
        ...mapState(['operators', 'chatType', 'chatTypes']),

    },
    watch: {
      operators(newOperators) {
        if (newOperators.length === 0 && !this.isHandlingEmptyOperators) {
          this.isHandlingEmptyOperators = true;
          this.offlineForm();
        } else {
          newOperators.forEach(operator => {
            if (operator.vcavatar) {
              this.checkIfExist(operator.vcavatar).then((exists) => {
                this.$set(this.avatarsStatus, operator.operatorid, exists);
              });
            } else {
              this.$set(this.avatarsStatus, operator.operatorid, false);
            }
          });
        }
      }
    },
    beforeMount() {
        this.$store.http.checkForOperators(this.chatTypes[this.chatType].id);
    },
    methods: {
        handleOperatorsListed() {
            this.operatorsLoaded = true;
        },
        chooseOperator(operatorId) {
            this.$store.commit("setGroupId", null);
            showLoadingScreen();
            this.$store.http.createThreadWithOperatorId(this.chatType, this.chatTypes[this.chatType].id, operatorId);
        },
        offlineForm() {
            changeChatWindowStatus(4);
        },
        checkIfExist(url) {
          return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = url;
          });
        },

    },
    mounted() {
        EventBus.$on('operatorsListed', this.handleOperatorsListed);
        this.$nextTick(() => {
            if (this.$refs.selectOperator) {
                this.$refs.selectOperator.scrollTop = 0;
            }
        });
    },
    beforeDestroy() {
        EventBus.$off('operatorsListed', this.handleOperatorsListed);
    }
}
</script>
